"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberStr = exports.parseStreetAddress = exports.isValidHtml = exports.stripHtml = exports.replaceSlashAndDashes = exports.replaceHyphenWithSplitAndShift = exports.hasThisWord = exports.objectToQueryString = exports.formatToBase64 = exports.replaceFileType = exports.replaceStringToNumber = exports.replaceAutoSlashDate = exports.transformSecondsToWords = exports.maskEmail = exports.isLongerThan = exports.isShorterThan = exports.hasSequentialNumberMorethanAllowedNumber = exports.hasRepetitiveNumberMorethanAllowedNumber = exports.hasSpecialCharForPhone = exports.hasAlphaChar = exports.hasSpecialChar = exports.hasNumericChar = exports.isAlphaSpaceString = exports.isNumericStringWithSpace = exports.isAlphabet = exports.isNumericString = exports.hasUppercase = exports.hasLowercase = exports.isWebsiteFormatValid = exports.isPhoneFormatValid = exports.isEmailFormatValid = exports.startCase = void 0;
const startCase = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
exports.startCase = startCase;
const isEmailFormatValid = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};
exports.isEmailFormatValid = isEmailFormatValid;
const isPhoneFormatValid = (phone) => {
    const re = /^(\({1}\d{3}\){1}[\s]\d{3}[-]\d{4})$|^(\d{3}[\s]\d{3}[\s]\d{4})$|^(\d{3}[-]\d{3}[-]\d{4})$|^(\d{3}\d{3}\d{4})$/;
    return re.test(phone);
};
exports.isPhoneFormatValid = isPhoneFormatValid;
const isWebsiteFormatValid = (website) => {
    const re = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    return re.test(website);
};
exports.isWebsiteFormatValid = isWebsiteFormatValid;
const hasLowercase = (string) => {
    const re = /^.*[a-z]/;
    return re.test(string);
};
exports.hasLowercase = hasLowercase;
const hasUppercase = (string) => {
    const re = /^.*[A-Z]/;
    return re.test(string);
};
exports.hasUppercase = hasUppercase;
const isNumericString = (string) => {
    const re = /^[0-9]*$/;
    return re.test(string);
};
exports.isNumericString = isNumericString;
const isAlphabet = (string) => {
    const re = /^[a-zA-Z]+$/;
    return re.test(string);
};
exports.isAlphabet = isAlphabet;
const isNumericStringWithSpace = (string) => {
    const re = /^[0-9 ]*$/;
    return re.test(string);
};
exports.isNumericStringWithSpace = isNumericStringWithSpace;
const isAlphaSpaceString = (string) => {
    const re = /^([a-zA-Z]+\s)*[a-zA-Z]+$/;
    return re.test(string);
};
exports.isAlphaSpaceString = isAlphaSpaceString;
const hasNumericChar = (string) => {
    const re = /^.*[0-9]/;
    return re.test(string);
};
exports.hasNumericChar = hasNumericChar;
const hasSpecialChar = (string) => {
    const re = /["!#$%&’()*+,-./\\:;<=>?@[\]\^_`{|}~]/;
    return re.test(string);
};
exports.hasSpecialChar = hasSpecialChar;
const hasAlphaChar = (string) => {
    const re = /^.*[a-zA-Z]/;
    return re.test(string);
};
exports.hasAlphaChar = hasAlphaChar;
const hasSpecialCharForPhone = (string) => {
    const re = /[!@#$%^&*`~()_\=\[\]{};':"\\|,.<>\/?]+/; // special char without "+" and "-"
    return re.test(string);
};
exports.hasSpecialCharForPhone = hasSpecialCharForPhone;
const hasRepetitiveNumberMorethanAllowedNumber = (string, allowedRepetitiveNumberCount) => {
    const re = new RegExp(`(.)(\\1{${allowedRepetitiveNumberCount},})`);
    return re.test(string);
};
exports.hasRepetitiveNumberMorethanAllowedNumber = hasRepetitiveNumberMorethanAllowedNumber;
const hasSequentialNumberMorethanAllowedNumber = (string, allowedSequentialNumberCount) => {
    const patterns = ['01234567890', '09876543210'];
    const findSequence = (pattern) => {
        const number = string.split('');
        let commons = [];
        for (const num of number) {
            const common = commons.join('').concat(num);
            if (pattern.includes(common)) {
                commons.push(num);
                if (commons.length > allowedSequentialNumberCount)
                    return true;
            }
            else {
                commons = [];
            }
        }
        return commons.length > allowedSequentialNumberCount;
    };
    return findSequence(patterns[0]) || findSequence(patterns[1]);
};
exports.hasSequentialNumberMorethanAllowedNumber = hasSequentialNumberMorethanAllowedNumber;
const isShorterThan = (string, length) => {
    return string && string.length < length;
};
exports.isShorterThan = isShorterThan;
const isLongerThan = (string, length) => {
    return string && string.length > length;
};
exports.isLongerThan = isLongerThan;
const maskEmail = (email) => {
    const wrongEmail = 'wrong email';
    if (!Boolean(email) || email.indexOf('@') === -1) {
        return wrongEmail;
    }
    const [name, domain] = email.split('@');
    if (!Boolean(name) || !Boolean(domain)) {
        return wrongEmail;
    }
    const prefixFirst = name[0];
    const prefixLast = name.length > 1 ? name[name.length - 1] : '';
    const maskedPrefix = `${prefixFirst}****${prefixLast}`;
    return `${maskedPrefix}@${domain}`;
};
exports.maskEmail = maskEmail;
const transformSecondsToWords = (seconds) => {
    const rawSeconds = Number(seconds);
    const numHours = Math.floor(rawSeconds / 3600);
    const numMinutes = Math.floor((rawSeconds % 3600) / 60);
    const numSeconds = Math.floor((rawSeconds % 3600) % 60);
    // eslint-disable-next-line eqeqeq
    const hDisplay = numHours > 0 ? numHours + (numHours == 1 ? ' hour ' : ' hours ') : '';
    // eslint-disable-next-line eqeqeq
    const mDisplay = numMinutes > 0 ? numMinutes + (numMinutes == 1 ? ' minute ' : ' minutes ') : '';
    // eslint-disable-next-line eqeqeq
    const sDisplay = numSeconds > 0 ? numSeconds + (numSeconds == 1 ? ' second' : ' seconds') : '';
    return hDisplay + mDisplay + sDisplay;
};
exports.transformSecondsToWords = transformSecondsToWords;
const replaceAutoSlashDate = (dateToFormat) => dateToFormat
    .replace(/^(\d\d)(\d)$/g, '$1/$2')
    .replace(/^(\d\d\/\d\d)(\d+)$/g, '$1/$2')
    .replace(/[^\d\/]/g, ''); // eslint-disable-line no-useless-escape
exports.replaceAutoSlashDate = replaceAutoSlashDate;
const replaceStringToNumber = (value) => {
    return Number(value === null || value === void 0 ? void 0 : value.replace(/^\D+/g, ''));
};
exports.replaceStringToNumber = replaceStringToNumber;
const replaceFileType = (fileName) => {
    return fileName.replace(/\.[^/.]+$/, '');
};
exports.replaceFileType = replaceFileType;
const formatToBase64 = (type) => {
    return Buffer.from(type).toString('base64');
};
exports.formatToBase64 = formatToBase64;
const objectToQueryString = (object) => {
    var _a, _b;
    return ((_a = Object === null || Object === void 0 ? void 0 : Object.keys(object)) === null || _a === void 0 ? void 0 : _a.length)
        ? (_b = Object.entries(object)) === null || _b === void 0 ? void 0 : _b.reduce((acc, item) => [...acc, `${item[0]}=${item[1]}`], []).join('&')
        : '';
};
exports.objectToQueryString = objectToQueryString;
const hasThisWord = (text, word) => {
    const re = new RegExp(`${word}`, 'i');
    return text.match(re) !== null;
};
exports.hasThisWord = hasThisWord;
const replaceHyphenWithSplitAndShift = (text) => {
    var _a, _b;
    return (_b = (_a = text === null || text === void 0 ? void 0 : text.replace('-', '')) === null || _a === void 0 ? void 0 : _a.split(' ')) === null || _b === void 0 ? void 0 : _b.shift();
};
exports.replaceHyphenWithSplitAndShift = replaceHyphenWithSplitAndShift;
const replaceSlashAndDashes = (dirtyString) => {
    const newString = dirtyString.replace(/[\s\/\-]/g, '');
    return newString || '';
};
exports.replaceSlashAndDashes = replaceSlashAndDashes;
const stripHtml = (dirtyString) => {
    const doc = dirtyString.replace(/(<([^>]+)>)/gi, '');
    return doc || '';
};
exports.stripHtml = stripHtml;
const isValidHtml = (dirtyString) => {
    const doc = new DOMParser().parseFromString(dirtyString, 'text/html');
    const errorNode = doc.querySelector('parsererror');
    if (errorNode) {
        // parsing failed
        return false;
    }
    {
        const bodyNode = doc.querySelector('body');
        if (dirtyString !== bodyNode.innerHTML) {
            return false;
        }
    }
    return true;
};
exports.isValidHtml = isValidHtml;
const parseStreetAddress = (street) => {
    if (!street)
        return { addressLine1: '', addressLine2: '' };
    const [addressLine1 = '', addressLine2 = ''] = street.replace('||', '//').split('//').map(s => s.trim());
    return { addressLine1, addressLine2 };
};
exports.parseStreetAddress = parseStreetAddress;
const getNumberStr = (number, currency) => `${currency.sign}${(Number(number) / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
})}`;
exports.getNumberStr = getNumberStr;
//# sourceMappingURL=StringHelpers.js.map